/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxFudisModule } from '@funidata/ngx-fudis';
import { UIRouterModule } from '@uirouter/angular';
import { SisCommonModule } from 'sis-common';
import { SisComponentsModule } from 'sis-components/sis-components.module';
import { StudentCommonModule } from '../common/common.module';
import { ShowSummerPeriodCheckboxComponent } from './summer-period-checkbox/show-summer-period-checkbox.component';
import { ShowSummerPeriodService } from './summer-period-checkbox/show-summer-period.service';
import { TimelineZoomComponent } from './timeline-zoom/timeline-zoom.component';
import { TimelineCourseUnitComponent } from './timeline/timeline-course-unit/timeline-course-unit.component';
import { TimelineStudyRightIndicatorComponent } from './timeline/timeline-study-right-indicator/timeline-study-right-indicator.component';
import { TimelineComponent } from './timeline/timeline.component';
import { ModuleTimingTemplateComponent } from './timing-templates/module-timing-template/module-timing-template.component';
import { TimingTemplatesComponent } from './timing-templates/timing-templates.component';
import { TimingComponent } from './timing.component';
import { TIMING_NG_ENABLED } from './timing.constants';
import { states } from './timing.route';

@NgModule({
    declarations: [
        TimingComponent,
        TimelineComponent,
        TimelineCourseUnitComponent,
        TimelineStudyRightIndicatorComponent,
        TimelineZoomComponent,
        ShowSummerPeriodCheckboxComponent,
        TimingTemplatesComponent,
        ModuleTimingTemplateComponent,
    ],
    imports: [
        CommonModule,
        NgxFudisModule,
        SisCommonModule,
        SisComponentsModule,
        UIRouterModule.forChild({ states: TIMING_NG_ENABLED ? states : [] }),
        StudentCommonModule,
    ],
    providers: [ShowSummerPeriodService],
})
export class TimingModule {}
